<template>
  <div class="Ribbon">
    <canvas id="camerafeed"/>  
    <Lines ref="lines" v-if="ready"/>
  </div>
</template>

<script>

import gsap from "gsap"
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import Lines from './assets/Lines.vue'

export default {

  name: 'Ribbon',
  components: { Lines },
  data: ()=>({
    meshes: [],
    cues: [],
    helpers: [],
    ready: false,
    placed: false,
    on_placed: false,
    on_weave: false,
    max_length: 1000,
    osc: 10,
  }),

  computed: {
    touch_screen() { return this.$store.getters['app/touch_screen'] },
    scale() { return this.$store.getters['app/scale'] },
    rotation() { return this.$store.getters['app/rotation'] },
    recenter() { return this.$store.getters['app/recenter'] },
  },
  watch: { 

    touch_screen(nw, od) { 
      if(nw == true){
        if(this.rafID)
          cancelAnimationFrame(this.rafID)
        this.$refs.lines.touchScreen(true)
        this.onLoop()
      }
      else {
        if(this.rafID)
          cancelAnimationFrame(this.rafID)  
        this.$store.commit('app/WEAVE_BUTTON', 'hide')
        this.$helper.visible = false
        this.$refs.lines.touchScreen(false)
      }
      this.on_weave = nw
    },

    scale(nw, od) { 
      this.osc += nw*.001
      this.$group.scale.set(this.osc, this.osc, this.osc)
    },

    rotation(nw, od) { 
      this.$group.rotation.y += nw*.01
    },

    recenter(nw, od) {  
      let scale = { x: .01 }
      this.$group.scale.set(scale.x, scale.x, scale.x)
      gsap.to(scale, { 
          duration: .5,
          x: 10, 
          ease: 'cubic.out',
          onUpdate: ()=> {
           this.$model.scale.set(scale.x, scale.x, scale.x)
          },
          delay: .25 
        })
      XR8.XrController.recenter()
    },

    '$route': {
      immediate: true,
      handler() {

        if(this.$route.params.section == 'support')
          return

        // if(this.$root.route.from.params.section == 'recenter')   
        //   this.$router.push({ params: { section: 'weave' }})

        if(this.$root.route.from.params.section == 'recenter'
        && this.$route.params.section == undefined
        || this.$root.route.from.params.section == 'weave'
        && this.$route.params.section == undefined
        || this.$root.route.from.params.section == 'story'
        && this.$route.params.section == undefined
        || this.$root.route.from.params.section == 'finish'
        && this.$route.params.section == undefined){
          this.closeAndReset()
        }
        else if(this.$root.route.to.params.section == 'story'){ 
          XR8.pause() 
        }
        else if(this.$root.route.from.params.section == 'story'
             && this.$root.route.to.params.section != 'voice'
             && this.$root.route.to.params.section != 'words'){ 

          gsap.delayedCall(.1, ()=>{ 
            this.$router.push({ params: { section: undefined }})
          })

        }
        else if(this.$route.params.section == undefined) {
          //
          // this.reset()
          //
        }  
      }
    }

  },

  mounted() {

    // console.log('Ribbon');
    // window.alert('24')

    const placegroundScenePipelineModule = () => {

      const modelFile = './static/loom24.glb'  
      const startScale = new THREE.Vector3(0.01, 0.01, 0.01)  // Initial scale value for our model
      const endScale = new THREE.Vector3(10, 10, 10)             // Ending scale value for our model
      const animationMillis = 750                             // Animate over 0.75 seconds
      const raycaster = new THREE.Raycaster()
      const tapPosition = new THREE.Vector2()

      let surface

      const initXrScene = ({ scene, camera, renderer }) => {

        this.$store.commit('app/UPDATE_STATUS', 'logo')

        renderer.shadowMap.enabled = true
        renderer.shadowMap.type = THREE.PCFSoftShadowMap

        const light = new THREE.DirectionalLight(0xffffff, 2.5, 100)
        light.position.set(1, 4.3, 2.5)  

        scene.add(light) 
        scene.add(new THREE.AmbientLight(0xffffff, 1)) 

        light.shadow.mapSize.width = 1024  
        light.shadow.mapSize.height = 1024  
        light.shadow.camera.near = 0.5 
        light.shadow.camera.far = 500 
        light.castShadow = true

        renderer.toneMapping = THREE.ACESFilmicToneMapping
        // renderer.toneMappingExposure =  Math.pow( 1.25, 0.0 );
        // renderer.outputEncoding = THREE.sRGBEncoding

        surface = new THREE.Mesh(
          new THREE.PlaneGeometry(100, 100, 1, 1),
          new THREE.ShadowMaterial({
            opacity: 0.25,
          })
        )

        surface.rotateX(-Math.PI / 2)
        surface.position.set(0, 0, 0)
        surface.receiveShadow = true
        scene.add(surface)

        camera.position.set(0, 0, 0)

        const sphereGeomtry = new THREE.SphereBufferGeometry( this.line_size )
        const sphereMaterial = new THREE.MeshBasicMaterial( { color: this.line_color } )
        
        this.$helper = new THREE.Mesh(sphereGeomtry, sphereMaterial)
        this.$helper.position.set(0, 0, -1)  

        camera.add(this.$helper)

        this.$helper.visible = false
        this.$scene = XR8.Threejs.xrScene().scene
      }

      const animateIn = (model, pointX, pointZ, yDegrees) => {

        const scale = { ...startScale }

        model.scene.children[0].children[0].castShadow = true

        // model.scene.children[0].children[1].castShadow = true
        // model.scene.children[0].children[2].castShadow = true

        model.scene.children[1].castShadow = true
        model.scene.children[2].castShadow = true

        // const obj = model.scene.getObjectByName( "Mesh020_1" )
        // const clone = obj.material.clone()
        // const mesh020 = model.scene.getObjectByName( "Mesh020" )
        //       mesh020.material = clone
        // const mesh020_2 = model.scene.getObjectByName( "Mesh020_2" )
        //       mesh020_2.material = clone
        // const mesh020_3 = model.scene.getObjectByName( "Mesh020_3" )
        //       mesh020_3.material = clone

        
        model.scene.traverse ( ( o ) => {

        

          // if(o.name == 'strings_h_1_1'
          // || o.name == 'strings_h_1_2'
          // || o.name == 'strings_h_1_3'
          // || o.name == 'strings_h_1_4'
          // || o.name == 'strings_h_1_5'
          // || o.name == 'strings_h_1_6'
          // || o.name == 'strings_h_1_7'
          // || o.name == 'strings_h_1_8'
          // || o.name == 'strings_h_1_9'
          // || o.name == 'strings_h_1_10'
          // || o.name == 'strings_h_1_11'
          // || o.name == 'strings_h_1_12'
          // ){

          if(o.name == 'Strings_h_18001'
          || o.name == 'Strings_h_17001'
          || o.name == 'Strings_h_16001'
          || o.name == 'Strings_h_15001'
          || o.name == 'Strings_h_14001'
          || o.name == 'Strings_h_13001'
          || o.name == 'Strings_h_12001'
          || o.name == 'Strings_h_11001'
          || o.name == 'Strings_h_10001'
          || o.name == 'Strings_h_09001'
          || o.name == 'Strings_h_08001'
          || o.name == 'Strings_h_07001'
          || o.name == 'Strings_h_06001'
          || o.name == 'Strings_h_05001'
          || o.name == 'Strings_h_04001'
          || o.name == 'Strings_h_03001'
          || o.name == 'Strings_h_02001'
          || o.name == 'Strings_h_01001'

          ){

            // o.material.transparent = true
            // o.material.opacity = 0

            o.visible = false

            this.meshes.push(o)
          }
        })

        this.$group = new THREE.Object3D()
        this.$model = model.scene
        this.ready = true

        XR8.Threejs.xrScene().scene.add(this.$group)
        this.$group.add(model.scene)

        this.$group.rotation.set(0.0, yDegrees, 0.0)
        this.$group.position.set(pointX, 0.0, pointZ)
        this.$group.scale.set(scale.x, scale.y, scale.z)

        const sphereGeomtry = new THREE.SphereBufferGeometry( .001 )
        const sphereMaterial = new THREE.MeshBasicMaterial( { color: 0xdb2000 } )
        
        this.$entry = new THREE.Mesh(sphereGeomtry, sphereMaterial)
        this.$entry.position.set(0.07225, .1690, .04)
        this.$entry.visible = false
        this.$group.add(this.$entry)

        this.$right = new THREE.Mesh(sphereGeomtry, sphereMaterial)
        this.$right.position.set(0.07225, .1690, -.0365)
        this.$right.visible = false
        this.$group.add(this.$right)

        gsap.to(scale, { 
          duration: .5,
          x: 10, 
          ease: 'cubic.out',
          onUpdate: ()=> {
            this.$group.scale.set(scale.x, scale.x, scale.x)
          },
          delay: .25 
        })
      }

      const placeObject = (pointX, pointZ, camera) => {

        this.$store.commit('app/UPDATE_STATUS', 'loading')

        if(this.on_placed)
          return
        this.on_placed = true

        const dracoLoader = new DRACOLoader()
              dracoLoader.setDecoderPath('three/examples/js/libs/draco/gltf/')
        const loader = new GLTFLoader()
              loader.setDRACOLoader( dracoLoader )
              loader.load( modelFile,  (glb)=> { 
                this.$store.commit('app/UPDATE_STATUS', 'completed')
                gsap.delayedCall(0.5, ()=>{ animateIn(glb, pointX, pointZ, (Math.PI/180)*-90) })   
                gsap.delayedCall(1.5, ()=>{ needRecenter() })   
                   
            })
      }

      const needRecenter = ()=> {
        this.placed = true
        this.$canvas.removeEventListener('touchstart', this.$onTouchStart, true) 
        this.$router.push({ params: { section: 'recenter' } })
      }

      // const beforeOnLoop = (camera)=> {
      //   this.placed = true
      //   this.$router.push({ params: { section: 'weave' } })
      //   this.$canvas.removeEventListener('touchstart', this.$onTouchStart, true) 
      // }

      const placeObjectTouchHandler = (e) => {

        // if (e.touches.length === 2) { XR8.XrController.recenter() }
        if (e.touches.length > 1) { return }

        const { camera } = XR8.Threejs.xrScene()
        tapPosition.x = (e.touches[0].clientX / window.innerWidth) * 2 - 1
        tapPosition.y = -(e.touches[0].clientY / window.innerHeight) * 2 + 1
        raycaster.setFromCamera(tapPosition, camera)
        const intersects = raycaster.intersectObject(surface)
        if (intersects.length === 1 && intersects[0].object === surface) 
          placeObject(intersects[0].point.x, intersects[0].point.z, camera)  
      }

      this.$onTouchStart = (e)=> { placeObjectTouchHandler(e) }
      
      return {
        name: 'placeground',
        onStart: ({ canvas }) => {
          const { scene, camera, renderer } = XR8.Threejs.xrScene()  
          initXrScene({ scene, camera, renderer })
          this.$canvas = canvas
          this.$canvas.addEventListener('touchstart', this.$onTouchStart, true)  
          const animate = (time) => {
            requestAnimationFrame(animate)
          }
          animate()
          XR8.XrController.updateCameraProjectionMatrix({
            origin: camera.position,
            facing: camera.quaternion,
          })
        },
      }
    }

    const onxrloaded = () => {
      XR8.addCameraPipelineModules([  
        XR8.GlTextureRenderer.pipelineModule(),     
        XR8.Threejs.pipelineModule(),               
        XR8.XrController.pipelineModule(),         
        XRExtras.AlmostThere.pipelineModule(),       
        XRExtras.FullWindowCanvas.pipelineModule(),  
        XRExtras.Loading.pipelineModule(),          
        XRExtras.RuntimeError.pipelineModule(),     
        placegroundScenePipelineModule(),
      ])
      XR8.run({canvas: document.getElementById('camerafeed')})
    }

    const load = () => { XRExtras.Loading.showLoading({ onxrloaded }) }
    window.onload = () => { window.XRExtras ? load() : window.addEventListener('xrextrasloaded', load) }

  },

  methods:{

    // beforeOnLoop(){
    //   this.placed = true
    //   this.$router.push({ params: { section: 'weave' } })
    //   this.$canvas.removeEventListener('touchstart', this.$onTouchStart, true) 
    // },

    closeModel() {
      return new Promise(res => { 
        if(this.$group) {
          const scale = { x: 10 }
          gsap.to(scale, { 
            duration: .35,
            x: .1, 
            ease: 'cubic.out',
            onUpdate: ()=> {
              this.$group.scale.set(scale.x, scale.x, scale.x)
            },
            onComplete: ()=>{
             res()
            },
            delay: .25 
          })
        }
        else
          res() 
      })
    },
    closeAndReset: async function() {          
      this.eraseLines()
      await this.closeModel()
      this.reset()
    },
    eraseLines() {
      this.ready = false
    },
    reset() {

      if(this.$root.route.from.params.section != 'finish')
        this.$store.commit('app/UPDATE_STATUS', 'init')

      if(this.$model)
        this.$scene.remove(this.$group)   
      this.meshes = []
      this.on_placed = false
      this.placed = false
      this.osc = 10
      this.$canvas.addEventListener('touchstart', this.$onTouchStart, true)  
      gsap.delayedCall(.25, ()=>XR8.resume()) 
    },

    onLoop() {
      let cue = this.getCue()
      let add = true
      if(this.cues.length >= this.max_length){
        this.$store.commit('app/TOUCH_SCREEN', false)
        return
      }
      if(this.cues.length >2) {
        const dist = this.calculateDistance(this.cues[this.cues.length-1], cue)
        if(dist < .002)
          add = false
      } 
      if(add){
        this.cues.push(cue)
        if(this.cues.length >2)
          this.$refs.lines.addLineSegment()
      }
      this.rafID = requestAnimationFrame(this.onLoop)  
    },
    getCue() {
      const wdp = this.$helper.getWorldPosition()
      return new THREE.Vector3(wdp.x, wdp.y, wdp.z)
    },
    calculateDistance(p1, p2) {
      let a = p2.x - p1.x
      let b = p2.y - p1.y
      let c = p2.z - p1.z
      return Math.hypot(a, b, c)
    }, 
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Ribbon
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

#camerafeed
  z-index 300

#almostthereContainer
  display none !important

</style>


